(function () {
  var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
  var PENDING_MODAL_KEY = "marmorisPendingMarketModal";
  var MARKET_STATE_KEY = "marmorisMarketState";
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000;
  var MARKET_DEFINITIONS = {
    TH: { code: "TH", name: "Thailand", defaultPath: "/en-th", paths: ["/en-th"] },
    SG: {
      code: "SG",
      name: "Singapore",
      defaultPath: "/en-sg",
      paths: ["/en-sg", "/zh-sg"],
    },
    JP: { code: "JP", name: "Japan", defaultPath: "/ja-jp", paths: ["/en-jp", "/ja-jp"] },
    MY: { code: "MY", name: "Malaysia", defaultPath: "/en-my", paths: ["/en-my"] },
    CN: { code: "CN", name: "China", defaultPath: "/zh-cn", paths: ["/en-cn", "/zh-cn"] },
    KR: { code: "KR", name: "South Korea", defaultPath: "/ko-kr", paths: ["/ko-kr"] },
    AU: { code: "AU", name: "Australia", defaultPath: "/en-au", paths: ["/en-au"] },
    HK: { code: "HK", name: "Hong Kong", defaultPath: "/zh-hk", paths: ["/zh-hk"] },
    TW: { code: "TW", name: "Taiwan", defaultPath: "/zh-tw", paths: ["/zh-tw"] },
  };
  var MARKET_PREFIXES = Object.keys(MARKET_DEFINITIONS).reduce(function (prefixes, code) {
    return prefixes.concat(MARKET_DEFINITIONS[code].paths);
  }, []);
  var MARKET_BY_COUNTRY = {
    TH: MARKET_DEFINITIONS.TH,
    SG: MARKET_DEFINITIONS.SG,
    JP: MARKET_DEFINITIONS.JP,
    MY: MARKET_DEFINITIONS.MY,
    CN: MARKET_DEFINITIONS.CN,
    KR: MARKET_DEFINITIONS.KR,
    AU: MARKET_DEFINITIONS.AU,
    HK: MARKET_DEFINITIONS.HK,
    TW: MARKET_DEFINITIONS.TW,
  };
  var GLOBAL_MARKET = { code: "GL", name: "Global", path: "/" };

  function dispatchMarketDetectState(state) {
    document.dispatchEvent(
      new CustomEvent("market-detect:state", {
        detail: {
          state: state,
        },
      }),
    );
  }

  function safeParse(value) {
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function readTimedStorage(key) {
    var storedValue = null;
    try {
      storedValue = window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }

    var parsed = safeParse(storedValue);
    if (!parsed || !parsed.expiresAt) return null;

    if (Number(parsed.expiresAt) <= Date.now()) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        return null;
      }
      return null;
    }

    return parsed;
  }

  function readMarketState() {
    var parsed = readTimedStorage(MARKET_STATE_KEY);
    if (!parsed) return null;

    return parsed;
  }

  function isModalDismissed() {
    var state = readMarketState();
    return !!(state && state.dismissedAt);
  }

  function saveMarketState(updates) {
    var currentState = readMarketState() || {};
    try {
      window.localStorage.setItem(
        MARKET_STATE_KEY,
        JSON.stringify(
          Object.assign({}, currentState, updates, {
            expiresAt: Date.now() + STORAGE_TTL,
          }),
        ),
      );
    } catch (error) {
      return;
    }
  }

  function saveModalDismissed(marketCode) {
    saveMarketState({
      marketCode: marketCode || null,
      dismissedAt: Date.now(),
    });
  }

  function readManualMarketSelection() {
    var parsed = readMarketState();
    if (!parsed || !parsed.dismissedAt) return null;

    return parsed;
  }

  function savePendingModal(payload) {
    try {
      window.sessionStorage.setItem(PENDING_MODAL_KEY, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function readPendingModal() {
    var storedValue = null;
    try {
      storedValue = window.sessionStorage.getItem(PENDING_MODAL_KEY);
    } catch (error) {
      return null;
    }

    var parsed = safeParse(storedValue);
    if (!parsed || !parsed.marketCode) return null;

    return parsed;
  }

  function clearPendingModal() {
    try {
      window.sessionStorage.removeItem(PENDING_MODAL_KEY);
    } catch (error) {
      return;
    }
  }

  function getCurrentPrefix(pathname) {
    var path = pathname || window.location.pathname || "/";

    for (var index = 0; index < MARKET_PREFIXES.length; index += 1) {
      var prefix = MARKET_PREFIXES[index];
      if (path === prefix || path.indexOf(prefix + "/") === 0) return prefix;
    }

    return "/";
  }

  function stripMarketPrefix(pathname) {
    var path = pathname || "/";
    var currentPrefix = getCurrentPrefix(path);

    if (currentPrefix === "/") return path || "/";

    var stripped = path.slice(currentPrefix.length);
    return stripped || "/";
  }

  function buildMarketUrl(targetPath) {
    var cleanTarget = String(targetPath || "/").trim();
    return cleanTarget || "/";
  }

  function lookupMarket(code) {
    if (!code) return GLOBAL_MARKET;
    return MARKET_BY_COUNTRY[code] || GLOBAL_MARKET;
  }

  function getMarketByPath(pathname) {
    var prefix = getCurrentPrefix(pathname);
    var marketCodes = Object.keys(MARKET_BY_COUNTRY);

    for (var index = 0; index < marketCodes.length; index += 1) {
      var market = MARKET_BY_COUNTRY[marketCodes[index]];
      if (market.paths.indexOf(prefix) !== -1) return market;
    }

    return GLOBAL_MARKET;
  }

  function normalizeDetectedCode(payload) {
    var detectedCountry =
      payload && payload.detected_values && payload.detected_values.country;

    if (!detectedCountry) return "GL";

    var rawCode =
      detectedCountry.iso_code ||
      detectedCountry.country_code ||
      detectedCountry.code ||
      detectedCountry.handle ||
      "";

    var normalizedCode = String(rawCode).trim().toUpperCase();

    if (normalizedCode === "UK") normalizedCode = "GB";
    if (!MARKET_BY_COUNTRY[normalizedCode]) return "GL";

    return normalizedCode;
  }

  function getDetectedCountryName(payload, fallbackCode) {
    var detectedCountry =
      payload && payload.detected_values && payload.detected_values.country;

    if (!MARKET_BY_COUNTRY[fallbackCode]) return lookupMarket(fallbackCode).name;
    if (!detectedCountry) return lookupMarket(fallbackCode).name;

    return (
      detectedCountry.name ||
      detectedCountry.country_name ||
      detectedCountry.localized_name ||
      lookupMarket(fallbackCode).name
    );
  }

  function getFlagEmoji(code) {
    if (!code || code === "GL") return "🌐";

    return code
      .slice(0, 2)
      .toUpperCase()
      .split("")
      .map(function (character) {
        return String.fromCodePoint(character.charCodeAt(0) + 127397);
      })
      .join("");
  }

  function getModalCountryDisplay(detection) {
    var market = (detection && detection.market) || GLOBAL_MARKET;
    var detectedCountry = (detection && detection.detectedCountry) || GLOBAL_MARKET;

    if (!MARKET_BY_COUNTRY[market.code]) {
      return {
        code: GLOBAL_MARKET.code,
        name: "Worldwide",
      };
    }

    return {
      code: detectedCountry.code || market.code,
      name: detectedCountry.name || market.name,
    };
  }

  function createModalPayload(detection) {
    var detectedCountry = (detection && detection.detectedCountry) || GLOBAL_MARKET;
    var market = (detection && detection.market) || GLOBAL_MARKET;

    return {
      detectedCountry: detectedCountry,
      market: market,
      marketCode: market.code,
    };
  }

  function detectCountryMarket() {
    return fetch("/browsing_context_suggestions.json?country[enabled]=true", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to detect visitor country");
        return response.json();
      })
      .then(function (payload) {
        var detectedCode = normalizeDetectedCode(payload);
        var matchedMarket = lookupMarket(detectedCode);

        return {
          detectedCountry: {
            code: detectedCode,
            name: getDetectedCountryName(payload, detectedCode),
          },
          market: matchedMarket,
        };
      })
      .catch(function () {
        return {
          detectedCountry: {
            code: GLOBAL_MARKET.code,
            name: GLOBAL_MARKET.name,
          },
          market: GLOBAL_MARKET,
        };
      });
  }

  function bindManualMarketSelection() {
    function navigateToMarket(targetPath) {
      var nextUrl = buildMarketUrl(targetPath);
      var currentUrl =
        (window.location.pathname || "/") +
        (window.location.search || "") +
        (window.location.hash || "");

      if (nextUrl !== currentUrl) {
        window.location.assign(nextUrl);
      }
    }

    document.addEventListener("change", function (event) {
      if (isThemeEditor) return;
      var select = event.target;
      if (
        !select ||
        !select.classList ||
        !select.classList.contains("market-switcher")
      )
        return;

      navigateToMarket(select.value || "/");
    });

    document.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("[data-market-switch-path]");
      if (!link) return;
      if (isThemeEditor) {
        event.preventDefault();
        return;
      }
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      navigateToMarket(link.getAttribute("data-market-switch-path") || "/");
    });
  }

  function initModal(detection) {
    if (isThemeEditor) {
      dispatchMarketDetectState("ready");
      return;
    }
    var modal = document.querySelector("[data-market-detect-modal]");
    if (!modal) {
      dispatchMarketDetectState("ready");
      return;
    }

    var countryLabel = modal.querySelector("[data-market-detect-country]");
    var yesButton = modal.querySelector("[data-market-detect-yes]");
    var currentMarket = getMarketByPath(window.location.pathname || "/");
    var yesMarket = (detection && detection.market) || GLOBAL_MARKET;
    var displayCountry = getModalCountryDisplay(detection);

    if (countryLabel) {
      countryLabel.textContent =
        getFlagEmoji(displayCountry.code) + " " + displayCountry.name;
    }

    function closeModal(shouldPersistDismissal) {
      if (shouldPersistDismissal) saveModalDismissed(currentMarket.code);
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("market-detect-open");
      dispatchMarketDetectState("ready");
    }

    if (isModalDismissed()) {
      dispatchMarketDetectState("ready");
      return;
    }

    modal.classList.add("is-open");
    document.documentElement.classList.add("market-detect-open");
    dispatchMarketDetectState("open");

    function chooseMarket(market) {
      saveModalDismissed(market.code);

      if (currentMarket.code === market.code) {
        closeModal(false);
        return;
      }

      window.location.replace(buildMarketUrl(market.defaultPath || market.path));
    }

    if (yesButton) {
      yesButton.addEventListener("click", function () {
        chooseMarket(yesMarket);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindManualMarketSelection();

    if (isThemeEditor) {
      dispatchMarketDetectState("ready");
      return;
    }

    var pendingModal = readPendingModal();
    var currentMarket = getMarketByPath(window.location.pathname || "/");
    if (pendingModal) {
      clearPendingModal();
      initModal(pendingModal);
      return;
    }
    clearPendingModal();

    var manualMarketSelection = readManualMarketSelection();
    if (manualMarketSelection) {
      dispatchMarketDetectState("ready");
      return;
    }

    detectCountryMarket().then(function (detection) {
      var modalPayload = createModalPayload(detection);
      var detectedMarket = modalPayload.market || GLOBAL_MARKET;

      if (currentMarket.code !== detectedMarket.code) {
        savePendingModal(modalPayload);
        window.location.replace(buildMarketUrl(detectedMarket.defaultPath || detectedMarket.path));
        return;
      }

      initModal(modalPayload);
    });
  });
})();
